// import React, { useContext } from "react";
// import { SiteContext } from "../utils/SiteContext";
// import { styled } from "@mui/material/styles";
// import StyledTextField from "../components/StyledTextField";
// import { IconButton, InputAdornment, Button } from "@mui/material";
// import ClearIcon from "@mui/icons-material/Clear";
// import SearchIcon from "@mui/icons-material/Search";

// const Root = styled('div')(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
// }));

// const SearchField = styled(StyledTextField)(({ theme }) => ({
//   height: 35,
//   width: "40%",
//   marginRight: 10
// }));

// export default function SearchBar({ children, search, label }) {
//   const [searchVal, setSearch] = search;
//   const { loading } = useContext(SiteContext);
//   const [, setLoading] = loading;
// //   const [pageVal, setPage] = page;

//   const handleSearch = () => {
//     // setPage({ ...pageVal, page: 1 });
//     setLoading(true);
//   };

//   const handleClear = () => {
//     setSearch('');
//     setLoading(true);
//   };

//   return (
//     <Root>
//       <SearchField
//         id="searchBar-input"
//         variant="outlined"
//         size="small"
//         placeholder={`Search ${label}`}
//         value={searchVal}
//         color="primary"
//         onChange={(e) => setSearch(e.target.value)}
//         onKeyDown={(e) => {
//           if (e.key === 'Enter') {
//             handleSearch();
//           }
//         }}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon />
//             </InputAdornment>
//           ),
//           endAdornment: searchVal && (
//             <InputAdornment position="end">
//               <IconButton
//                 aria-label="clear search"
//                 onClick={handleClear}
//                 edge="end"
//                 size="small"
//               >
//                 <ClearIcon />
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//       />
//       <Button
//         variant="contained"
//         color="primary"
//         size="small"
//         onClick={handleSearch}
//       >
//         Search
//       </Button>
//       {children}
//     </Root>
//   );
// }


import React, { useContext } from "react";
import { SiteContext } from "../utils/SiteContext";
import { styled, useTheme } from "@mui/material/styles";
import StyledTextField from "../components/StyledTextField";
import {
  IconButton,
  InputAdornment,
  Button,
  Tooltip,
  useMediaQuery,
  Box,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  // Some breathing room between input and actions
  gap: theme.spacing(1),
  width: "100%",
}));

const SearchField = styled(StyledTextField)(({ theme }) => ({
  height: 35,
  width: "40%",           // default desktop width
  marginRight: 10,
  [theme.breakpoints.down("sm")]: {
    width: "100%",         // wider on mobile
    marginRight: 0,
  },
}));

export default function SearchBar({ children, search, label }) {
  const [searchVal, setSearch] = search;
  const { loading } = useContext(SiteContext);
  const [, setLoading] = loading;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSearch = () => {
    setLoading(true);
  };

  const handleClear = () => {
    setSearch("");
    setLoading(true);
  };

  return (
    <Root>
      <SearchField
        id="searchBar-input"
        variant="outlined"
        size="small"
        // fullWidth
        placeholder={`Search ${label}`}
        value={searchVal}
        color="primary"
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearch();
          }
        }}

        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize={isMobile ? "small" : "medium"} />
            </InputAdornment>
          ),
          endAdornment:
            !!searchVal && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="clear search"
                  onClick={handleClear}
                  edge="end"
                  size="small"
                >
                  <ClearIcon fontSize={isMobile ? "small" : "medium"} />
                </IconButton>
              </InputAdornment>
            ),
        }}
      />

      {/* Desktop / tablet: regular button with text */}
      {!isMobile && (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleSearch}
        >
          Search
        </Button>
      )}

      {/* Mobile: compact icon-only button */}
      {/* {isMobile && (
        <Tooltip title="Search" arrow>
          <IconButton
            variant="contained"
            color="primary"
            onClick={handleSearch}
            aria-label="search"
            size="small"
            sx={{
              // Keep icon button compact and aligned
              width: 36,
              height: 36,
            }}
          >
            <SearchIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )} */}

      {/* Any extra controls passed in */}
      {children}
    </Root>
  );
}
